import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useUser } from '../../../../hooks/use-user';
import { UserType } from '../../../../lib/interfaces/user';
import CourseDetailPage from './page';

const CourseDetailWrapper = () => {
  const { user } = useUser();
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();

  useEffect(() => {
    if (!user) return;
    if (user.userType !== UserType.Internal) {
      navigate('/', { replace: true });
    }
  }, [user, navigate]);

  if (!id) return null;

  return (
    <div className="flex flex-col gap-5 h-full min-h-0">
      <CourseDetailPage courseId={id} />
    </div>
  );
};

export default CourseDetailWrapper;
